const pageNameKey = "vncpage";

export const vncpageEn = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Tomorrow Things Logo",
    disconnectButton: "Close",
    detectingVNCcompatibilityText: "Detecting VNC compatibility...",
    authenticationRequiredText: "Authentication required",
    failedToConnectVncText: "Failed to connect VNC",
    connectedToSourceText: "Connected to {sourceName} ({companyName})",
    disconnectedFromSourceText:
      "Connection lost, please close the tab and try again",
    authenticationFailedText:
      "Authentication failed, please close the tab and try again",
    authenticationFailedWithAllVersionsText:
      "Authentication failed with all versions",
    authenticatingText: "Authenticating...",
    testingAuthenticationText: "Testing authentication with VNC versions...",
    companyIconAltText: "Company Icon",
    enterVncPasswordPlaceholder: "Enter VNC password",
    submitButtonText: "Submit",
    machineAltText: "Machine",
    sourceIconAltText: "Source Icon",
    connectingVNCText: "Connecting to VNC...",
    sessionTerminatedText:
      "The session was terminated. You can now close this tab.",
  },
};

export const vncpagePtBr = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Logotipo da Tomorrow Things",
    disconnectButton: "Fechar",
    detectingVNCcompatibilityText: "Detectando compatibilidade com VNC...",
    authenticationRequiredText: "Autenticação necessária",
    failedToConnectVncText: "Falha ao conectar ao VNC",
    connectedToSourceText: "Conectado a {sourceName} ({companyName})",
    disconnectedFromSourceText:
      "Conexão perdida, feche a aba e tente novamente",
    authenticationFailedText:
      "Falha na autenticação, feche a aba e tente novamente",
    authenticationFailedWithAllVersionsText:
      "A autenticação falhou com todas as versões",
    authenticatingText: "Autenticando...",
    testingAuthenticationText: "Testando a autenticação com versões do VNC...",
    companyIconAltText: "Ícone da empresa",
    enterVncPasswordPlaceholder: "Digite a senha do VNC",
    submitButtonText: "Enviar",
    machineAltText: "Máquina",
    sourceIconAltText: "Ícone da fonte",
    connectingVNCText: "Conectando ao VNC...",
    sessionTerminatedText: "A sessão foi encerrada. Você pode fechar esta aba.",
  },
};

export const vncpageDe = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Tomorrow Things Logo",
    disconnectButton: "Schließen",
    detectingVNCcompatibilityText: "Ermittle VNC-Kompatibilität...",
    authenticationRequiredText: "Authentifizierung erforderlich",
    failedToConnectVncText: "Verbindung zu VNC fehlgeschlagen",
    connectedToSourceText: "Verbunden mit {sourceName} ({companyName})",
    disconnectedFromSourceText:
      "Verbindung verloren, bitte schließen Sie den Tab und versuchen Sie es erneut",
    authenticationFailedText:
      "Authentifizierung fehlgeschlagen, bitte schließen Sie den Tab und versuchen Sie es erneut",
    authenticationFailedWithAllVersionsText:
      "Authentifizierung mit allen Versionen fehlgeschlagen",
    authenticatingText: "Authentifiziere...",
    testingAuthenticationText: "Teste Authentifizierung mit VNC-Versionen...",
    companyIconAltText: "Firmen-Icon",
    enterVncPasswordPlaceholder: "VNC-Passwort eingeben",
    submitButtonText: "Absenden",
    machineAltText: "Maschine",
    sourceIconAltText: "Quell-Icon",
    connectingVNCText: "Verbinde mit VNC...",
    sessionTerminatedText:
      "Die Sitzung wurde beendet. Sie können diesen Tab jetzt schließen.",
  },
};

export const vncpageZhHans = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Tomorrow Things 徽标",
    disconnectButton: "关闭",
    detectingVNCcompatibilityText: "正在检测 VNC 兼容性...",
    authenticationRequiredText: "需要身份验证",
    failedToConnectVncText: "连接 VNC 失败",
    connectedToSourceText: "已连接到 {sourceName} ({companyName})",
    disconnectedFromSourceText: "连接丢失，请关闭标签页并重试",
    authenticationFailedText: "身份验证失败，请关闭标签页并重试",
    authenticationFailedWithAllVersionsText: "所有版本的身份验证均失败",
    authenticatingText: "正在进行身份验证...",
    testingAuthenticationText: "正在测试 VNC 版本的身份验证...",
    companyIconAltText: "公司图标",
    enterVncPasswordPlaceholder: "输入 VNC 密码",
    submitButtonText: "提交",
    machineAltText: "机器",
    sourceIconAltText: "源图标",
    connectingVNCText: "正在连接到 VNC...",
    sessionTerminatedText: "会话已被终止。您可以关闭此标签页。",
  },
};

export const vncpageIt = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Logo di Tomorrow Things",
    disconnectButton: "Chiudi",
    detectingVNCcompatibilityText:
      "Rilevamento della compatibilità per la connessione VNC...",
    authenticationRequiredText: "Autenticazione richiesta",
    failedToConnectVncText: "Connessione VNC non riuscita",
    connectedToSourceText: "Connesso a {sourceName} ({companyName})",
    disconnectedFromSourceText: "Connessione persa, chiudi la scheda e riprova",
    authenticationFailedText:
      "Autenticazione non riuscita, chiudi la scheda e riprova",
    authenticationFailedWithAllVersionsText:
      "Autenticazione non riuscita con nessuna delle versioni",
    authenticatingText: "Autenticazione in corso...",
    testingAuthenticationText:
      "Verifica dell'autenticazione con le versioni VNC...",
    companyIconAltText: "Icona aziendale",
    enterVncPasswordPlaceholder: "Inserisci la password VNC",
    submitButtonText: "Invia",
    machineAltText: "Macchina",
    sourceIconAltText: "Icona sorgente",
    connectingVNCText: "Connessione a VNC...",
    sessionTerminatedText:
      "La sessione è stata terminata. Puoi chiudere questa scheda.",
  },
};

export const vncpageEs = {
  [pageNameKey]: {
    tomorrowThingsLogoAltText: "Logo de Tomorrow Things",
    disconnectButton: "Cerrar",
    detectingVNCcompatibilityText: "Detectando la compatibilidad de VNC...",
    authenticationRequiredText: "Se requiere autenticación",
    failedToConnectVncText: "No se pudo conectar VNC",
    connectedToSourceText: "Conectado a {sourceName} ({companyName})",
    disconnectedFromSourceText:
      "Se perdió la conexión, por favor cierra la pestaña e inténtalo de nuevo",
    authenticationFailedText:
      "La autenticación falló, cierra la pestaña y vuelve a intentarlo",
    authenticationFailedWithAllVersionsText:
      "La autenticación falló con todas las versiones",
    authenticatingText: "Autenticando...",
    testingAuthenticationText: "Probando la autenticación con versiones VNC...",
    companyIconAltText: "Icono de la empresa",
    enterVncPasswordPlaceholder: "Introduce la contraseña de VNC",
    submitButtonText: "Enviar",
    machineAltText: "máquina",
    sourceIconAltText: "Icono de origen",
    connectingVNCText: "Conectando a VNC...",
    sessionTerminatedText:
      "La sesión fue terminada. Puedes cerrar esta pestaña.",
  },
};

export const vncpageNl = {
  [pageNameKey]: {
    authenticatingText: "Authenticeren...",
    authenticationFailedText:
      "Authenticatie mislukt, sluit het tabblad en probeer het opnieuw",
    authenticationFailedWithAllVersionsText:
      "Authenticatie met alle versies mislukt",
    authenticationRequiredText: "Authenticatie vereist",
    companyIconAltText: "Bedrijfspictogram",
    connectedToSourceText: "Verbonden met {sourceName} ({companyName})",
    connectingVNCText: "Verbinden met VNC...",
    detectingVNCcompatibilityText: "VNC-compatibiliteit detecteren...",
    disconnectButton: "Sluiten",
    disconnectedFromSourceText:
      "Verbinding verbroken, sluit het tabblad en probeer het opnieuw",
    enterVncPasswordPlaceholder: "VNC-wachtwoord invoeren",
    failedToConnectVncText: "Verbinden met VNC mislukt",
    machineAltText: "Machine",
    sourceIconAltText: "Bronpictogram",
    submitButtonText: "Verzenden",
    testingAuthenticationText: "Authenticatie testen met VNC-versies...",
    tomorrowThingsLogoAltText: "Tomorrow Things-logo",
    sessionTerminatedText:
      "De sessie is beëindigd. U kunt dit tabblad nu sluiten.",
  },
};

export const vncpageTr = {
  [pageNameKey]: {
    authenticatingText: "Kimlik doğrulanıyor...",
    authenticationFailedText:
      "Kimlik doğrulama başarısız oldu, lütfen sekmeyi kapatıp tekrar deneyin",
    authenticationFailedWithAllVersionsText:
      "Kimlik doğrulama tüm sürümlerde başarısız oldu",
    authenticationRequiredText: "Kimlik doğrulama gerekli",
    companyIconAltText: "Şirket Simgesi",
    connectedToSourceText: "{sourceName}'ye ({companyName}) bağlandı",
    connectingVNCText: "VNC'ye bağlanılıyor...",
    detectingVNCcompatibilityText: "VNC uyumluluğu algılanıyor...",
    disconnectButton: "Kapat",
    disconnectedFromSourceText:
      "Bağlantı kesildi, lütfen sekmeyi kapatıp tekrar deneyin",
    enterVncPasswordPlaceholder: "VNC şifresini girin",
    failedToConnectVncText: "VNC'ye bağlanılamadı",
    machineAltText: "Makine",
    sessionTerminatedText:
      "Oturum sonlandırıldı. Artık bu sekmeyi kapatabilirsiniz.",
    sourceIconAltText: "Kaynak Simgesi",
    submitButtonText: "Göndermek",
    testingAuthenticationText:
      "Kimlik doğrulaması VNC sürümleriyle test ediliyor...",
    tomorrowThingsLogoAltText: "Yarınki Şeyler Logosu",
  },
};
